import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=1c858022"
import script from "./TenantDetails.vue?vue&type=script&lang=js"
export * from "./TenantDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports